import { ViewChild, Component, Input } from '@angular/core';

import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventSchedule } from '../../../../model/rodeoEventSchedule';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { RunService } from '../../../../services/run.service';
import { PopoverController, LoadingController, ModalController, AlertController, ToastController, Events, Thumbnail } from 'ionic-angular';

import { UserSearchPopover } from '../../../search/user-search';
import { HorseSearchPopover } from '../../../search/horse-search';
import { Horse } from 'model/horse';
import { HorseService } from '../../../../services/horse.service';
import { AlertMessager } from '../../../../lib/alertMessager';
import { NewRunPage } from './new-run';
import { NavController } from 'ionic-angular';

import { Livestock } from '../../../../model/livestock';
import { RodeoService } from '../../../../services/rodeo.service';
import { ApiService } from '../../../../services/api';
import { Observable } from 'rxjs';
import { Organization } from '../../../../model/organization';
import { AccountHelper } from '../../../../lib/accountHelper';
import { RodeoEventRegistration } from '../../../../model/rodeoEventRegistration';
import { DrawPromptPage } from './draw-prompt';
import { PublishPromptPage } from './publish-prompt';
import { TextPromptPage } from './text-prompt';
import { DateHelperService } from '../../../../services/date-helper';

@Component({
    selector: 'staff-draw',
    templateUrl: 'draw.html'
})
export class DaySheetsSection {
    @ViewChild('optionsPopoverContent') optionsPopoverContent: any;
    _rodeo: Rodeo = new Rodeo();
    @Input() viewMode;
    @Input() disciplines;

    runChangedObservable;

    schedules: RodeoEventSchedule[] = [];
    selectedSchedule: RodeoEventSchedule;

    scheduleIndices: number[] = [];

    popoverActive: boolean = false;

    entrySearchChangeObservable;

    accountHelper: AccountHelper = AccountHelper.instance();

    pendingEntries: RodeoEventRegistration[];

    _organizations: any[] = [];

    selectedRound: any[];
    roundArray: any[];

    scheduleRuns: any[] = [];
    issues: any[] = [];

    isUnassigned = false;
    dtaFile: any;

    reNumberOnEdit: boolean;
    
    runHandler = (data) => this.changedSchedule();

    @Input()
    set rodeo(rodeo: Rodeo) {
        if (rodeo != null) {
            this._rodeo = new Rodeo();
            Object.assign(this._rodeo, rodeo);
            this.pendingEntries = [];
            this.selectedRound = [];
            this.roundArray = [];
            this.scheduleRuns = [];
            this.issues = [];
            this.schedules = [];

            this._rodeo.rodeoEvents.forEach((rodeoEvent) => {
                if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding'
                    || rodeoEvent.eventType === 'BarebackRiding')
                    rodeoEvent.roughStock = true;

                this.selectedRound[this._rodeo.rodeoEvents.indexOf(rodeoEvent)] = 1;

                this.roundArray[this._rodeo.rodeoEvents.indexOf(rodeoEvent)] = [];

                for (let i = 1; i <= rodeoEvent.rounds + (rodeoEvent.shortGo ? 1 : 0); i++) {
                    this.roundArray[this._rodeo.rodeoEvents.indexOf(rodeoEvent)].push(i);
                }

                rodeoEvent.schedules.forEach(schedule => {
                    if (schedule.name == 'Unassigned')
                        this.isUnassigned = true;

                    if (this.schedules.filter(x => x.name === schedule.name && x.scheduledDate == schedule.scheduledDate).length == 0)
                        this.schedules.push(schedule);

                    if (rodeoEvent.eventType !== 'BarrelRacing') {
                        schedule.runs.forEach(run => {
                            if (!run.livestock) {
                                run.livestock = new Livestock();
                                run.livestock.name = '';
                                run.livestock.brand = '';
                            }
                        });
                    }
                });

                this.pendingEntries.push(...rodeoEvent.registrations.filter(x => x.placed == false));
            });

            this.schedules.sort((a, b) => {
                let aDate = new Date(a.scheduledDate);
                let bDate = new Date(b.scheduledDate);

                return aDate > bDate ? 1 : aDate < bDate ? -1 : 0;
            });

            this.selectedSchedule = this.schedules[0];

            this.changedSchedule();
        }
    }
    get rodeo(): Rodeo {
        return this._rodeo;
    }

    @Input()
    set organizations(organizations: Organization[]) {
        if (organizations != null) {
            this._organizations = organizations;
        }
    }
    get organizations(): Organization[] {
        return this._organizations;
    }

    constructor(private runService: RunService, private popoverController: PopoverController, private modalCtrl: ModalController,
        private horseService: HorseService, private loadingControl: LoadingController, private alertController: AlertController,
        private alert: AlertMessager, private nav: NavController, private rodeoService: RodeoService, public api: ApiService,
        private toast: ToastController, private events: Events, public dateHelper: DateHelperService) { 
            this.events.subscribe('RunChangesHappened', this.runHandler);
        }


    onStartingChange(searchValue: string, index, run) {
        if (!this.entrySearchChangeObservable) {
            Observable.create(observer => {
                this.entrySearchChangeObservable = observer;
            }).debounceTime(450)
                .distinctUntilChanged()
                .subscribe((runChange) => {
                    this.updateRun(runChange.index, runChange.run);
                });
        }

        this.entrySearchChangeObservable.next({ search: index + 'starting' + searchValue, index: index, run: run });
    }

    onLiveStockChange(searchValue: string, index, run) {
        if (!this.entrySearchChangeObservable) {
            Observable.create(observer => {
                this.entrySearchChangeObservable = observer;
            }).debounceTime(5000)
                .distinctUntilChanged()
                .subscribe((runChange) => {
                    this.updateRun(runChange.index, runChange.run);
                });
        }

        this.entrySearchChangeObservable.next({ search: searchValue, index: index, run: run });
    }

    showTextPopup() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
    
        let popover = this.popoverController.create(TextPromptPage, {
            rodeo: this.rodeo,
            schedule: this.selectedSchedule
        }, {
            cssClass: 'page-new-publish'
        });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;
        });
    }

    showPublish(rodeoEvent: RodeoEvent, publish: boolean) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
    
        let popover = this.popoverController.create(PublishPromptPage, {
            rodeo: this.rodeo,
            rodeoEvent: rodeoEvent,
            schedule: this.selectedSchedule,
            publish: publish
        }, {
            cssClass: 'page-new-publish'
        });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;
        });
    }

    sendNotifications(rodeoEventId: number, scheduleId: number, stockPublish: boolean, publish: boolean) {
        let loading = this.loadingControl.create({
            content: publish ? 'Notifying contestants...' : 'Unpublishing runs...',
        });

        var message = "Success! ";
        var publishMessage = publish ? 'published' : 'unpublished';
        var selectedRodeoEvent = this.rodeo.rodeoEvents.find(x => x.id == rodeoEventId);
        var selectedSchedule = this.rodeo.rodeoEvents.flatMap(x => x.schedules).find(x => x.id == scheduleId);

        if (selectedSchedule)
            message += " " + selectedSchedule.name + ` has been ${publishMessage} for `;
        else
            message += ` All schedules have been ${publishMessage} for `;

        if (selectedRodeoEvent)
            message += " " + selectedRodeoEvent.displayName;
        else
            message += " all classes!";

        loading.present();

        if (publish) {
            this.rodeoService.sendRunNotifications(this.rodeo.id, rodeoEventId, scheduleId, stockPublish)
            .then((data: any) => {
                loading.dismiss();
                this.popoverActive = false;

                if (data.hasOwnProperty('message')) {
                    this.alert.showError("Run Notification Error", data.message);
                } else {
                    this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
                        if (rodeoEventId && rodeoEvent.id != rodeoEventId)
                            return;

                        rodeoEvent.schedules.forEach((schedule) => {
                        if (scheduleId && schedule.name != selectedSchedule.name)
                            return;

                            schedule.published = true;

                            if (stockPublish)
                                schedule.stockPublished = true;
                        }) 
                    });

                    this.toast.create({
                        message: message,
                        duration: 3000,
                        position: 'bottom'
                    }).present();
                }
            }, error => {
                loading.dismiss();
                this.popoverActive = false;
                console.log("Run Notification Error: ", error)
            });
        } else {
            this.rodeoService.unpublish(this.rodeo.id, rodeoEventId, scheduleId, stockPublish)
            .then((data: any) => {
                loading.dismiss();
                this.popoverActive = false;

                if (data.hasOwnProperty('message')) {
                    this.alert.showError("Run Notification Error", data.message);
                } else {
                    this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
                        if (rodeoEventId && rodeoEvent.id != rodeoEventId)
                            return;

                        rodeoEvent.schedules.forEach((schedule) => {
                        if (scheduleId && schedule.name != selectedSchedule.name)
                            return;

                            schedule.published = false;

                            if (stockPublish)
                                schedule.stockPublished = false;
                        }) 
                    });

                    this.toast.create({
                        message: message,
                        duration: 3000,
                        position: 'bottom'
                    }).present();
                }
            }, error => {
                loading.dismiss();
                this.popoverActive = false;
                console.log("Run Notification Error: ", error)
            });
        }
    }

    isPublishedAndContestantsNotified(): boolean {
        return this.rodeo.notifiedContestants && this.rodeo.rodeoEvents.every(event =>
                event.schedules.every(schedule => schedule.published)) ? true : false;
    }
    
    isPublishButtonDisabled(rodeoEvent: RodeoEvent, selectedSchedule: RodeoEventSchedule): boolean {
        const foundRodeoEventSchedule = rodeoEvent.schedules.find(schedule => schedule.name === selectedSchedule.name);
        return foundRodeoEventSchedule.published ? true : false;
    }

    matchSchedules(a: any, b: any) {
        return a == b;
    }

    changeListener($event): void {
        this.dtaFile = $event.target.files[0];
    }

    buildIssues(index: number) {
        this.issues[index] = [];

        if (!this.scheduleRuns[index] || this.scheduleRuns[index].length == 0)
            return;

        var startNumber = this.scheduleRuns[index][0].number;

        if (startNumber != 1)
            this.issues[index].push({ info: true, message:"The first draw number doesn't start at 1." });
        else
            startNumber = 0;

        this.scheduleRuns[index].forEach((run, runIndex) => {
            if (run.number == startNumber && runIndex > 0) {
                this.issues[index].push({ info: false, message:"You have duplicate draw numbers at " + run.number + "." });
                return;
            }

            if (run.number - startNumber > 1)
                this.issues[index].push({ info: true, message:"You have a draw number gap after " + startNumber + "." });

            if (run.number > 0)
                startNumber = run.number;
        });
    }

    importDTAFile() {
        if (this.popoverActive)
            return;

        let loader = this.loadingControl.create({
            content: 'Importing DTA File...',
        });

        loader.present();
        this.popoverActive = true;
        this.rodeoService.importDTAFile(this.dtaFile, this._rodeo.id)
            .then(data => {
                loader.dismiss();
                this.popoverActive = false;
                // console.log("data: ", data);
            }, error => {
                loader.dismiss();
                this.popoverActive = false;
                console.log("upload error: ", error)
            });
    }

    openUserSearch(event, rodeoEvent, index: number, run: RodeoEventRun, runIndex: number, teammateSearch) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(UserSearchPopover, {
            searchTitle: (teammateSearch ? this.getSecondLabel(rodeoEvent) : this.getFirstLabel(rodeoEvent)) + " Search",
            organizations: this._organizations
        }, { cssClass: 'user-search' });

        popover.present({ ev: event });

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                if (teammateSearch) {
                    this.scheduleRuns[index][runIndex].contestantTwoId = data.buddies[0].id;
                    this.scheduleRuns[index][runIndex].contestantTwo = data.buddies[0];
                    this.scheduleRuns[index][runIndex].horseTwo = null;
                } else {
                    // console.log("data.buddies[0]: ", data.buddies[0]);
                    this.scheduleRuns[index][runIndex].contestantOneId = data.buddies[0].id;
                    this.scheduleRuns[index][runIndex].contestantOne = data.buddies[0];
                    this.scheduleRuns[index][runIndex].horseOne = null;
                }

                this.updateRun(index, this.scheduleRuns[index][runIndex]);
            }
        });
    }

    openHorseSearch(event, rodeoEvent, index: number, run: RodeoEventRun, runIndex: number, horses) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(HorseSearchPopover, {
            searchTitle: "Horse Search",
            horses: horses
        }, { cssClass: 'horse-search' });

        popover.present({ ev: event });

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                let scheduleIndex = this.scheduleIndices[index];

                this.scheduleRuns[index][runIndex].horseOne = (data.horse as Horse);
                this.scheduleRuns[index][runIndex].horseOneId = (data.horse as Horse).id;

                this.updateRun(index, this.scheduleRuns[index][runIndex]);
            }
        });
    }

    openSecondSearch(event, rodeoEvent: RodeoEvent, index: number, run: RodeoEventRun, runIndex: number) {
        if (rodeoEvent.configuration.entries.showContestantTwo) {
            this.openUserSearch(event, rodeoEvent, index, run, runIndex, true);
        } else {
            let loading = this.loadingControl.create({
                content: 'Retrieving user horses...',
            });

            loading.present();
            this.horseService.getHorses([run.contestantOne.id])
                .then((data) => {
                    loading.dismiss();
                    this.openHorseSearch(event, rodeoEvent, index, run, runIndex, (data as Horse[]));
                }, error => {
                    loading.dismiss();
                    this.alert.showError("Horse Retrieval", "Unable to retrieve user horses.");
                });
        }
    }

    changedSelectedRound(rodeoEvent: RodeoEvent) {
        let index = this.rodeo.rodeoEvents.indexOf(rodeoEvent);
        let scheduleIndex = this.getScheduleIndex(rodeoEvent);

        if (scheduleIndex == -1)
            this.scheduleRuns[index] = [];
        else
            this.scheduleRuns[index] = this.rodeo.rodeoEvents[index].schedules[this.getScheduleIndex(rodeoEvent)].runs.filter(x => x.round == this.selectedRound[index]);

        this.scheduleRuns[index].sort((a, b) => {
            if (a.number < b.number)
                return -1;
            else if (a.number > b.number)
                return 1;
            
            return 0;
        });

        this.buildIssues(index);
    }
    //
    changedSchedule() {
        this.pendingEntries = [];
        this.scheduleIndices = [];
        this._rodeo.rodeoEvents.forEach(rodeoEvent => {
            this.pendingEntries.push(...rodeoEvent.registrations.filter(x => x.placed == false));
            let schedule = rodeoEvent.schedules.filter(x => x.name === this.selectedSchedule.name)[0];

            if (schedule && schedule.runs) {
                schedule.runs.forEach((run) => {
                    if (!run.livestock) {
                        run.livestock = new Livestock();
                        run.livestock.name = '';
                        run.livestock.brand = '';
                    }
                })
            }

            if (schedule)
                this.scheduleIndices.push(rodeoEvent.schedules.indexOf(schedule));
            else
                this.scheduleIndices.push(-1);

            this.changedSelectedRound(rodeoEvent);
        });
    }

    getRunPublishStatus(rodeoEvent: RodeoEvent) {
        return rodeoEvent.schedules.find(x => x.name == this.selectedSchedule.name && !x.published) != undefined ? `Runs NOT published` : `Runs published`;    
    }

    getStockPublishStatus(rodeoEvent: RodeoEvent) {
        return rodeoEvent.schedules.find(x => x.name == this.selectedSchedule.name && !x.stockPublished) != undefined ? 'Stock NOT published' : `Stock published`;
    }

    hasSchedule(rodeoEvent: RodeoEvent) {
        return rodeoEvent.schedules.filter(x => x.name === this.selectedSchedule.name).length > 0;
    }

    getSchedule(rodeoEvent: RodeoEvent) {
        return rodeoEvent.schedules.find(x => x.name === this.selectedSchedule.name);
    }

    getScheduleIndex(rodeoEvent: RodeoEvent) {
        return rodeoEvent.schedules.indexOf(rodeoEvent.schedules.filter(x => x.name === this.selectedSchedule.name)[0]);
    }

    getEntryCount(rodeoEvent: RodeoEvent, schedule: RodeoEventSchedule) {
        return rodeoEvent.registrations.filter(x => x.scheduleIds[0] == schedule.id).length;
    }

    getFirstLabel(rodeoEvent: RodeoEvent) {
        return rodeoEvent.configuration.runs.slotOneLabel;
    }

    getSecondDisplay(rodeoEvent: RodeoEvent, run: RodeoEventRun) {
        var secondDisplayValue = '';

        var valuesToDisplay = rodeoEvent.configuration.runs.slotTwoFieldName.split('+');

        valuesToDisplay.forEach(value => {
            var propertiesInValue = value.split('.');

            var objectWithValue: any;
            objectWithValue = run;

            var lastProperty = '';
            propertiesInValue.forEach(property => {
                if (!objectWithValue) {
                    objectWithValue = lastProperty == 'livestock' ? 'Livestock 1' : 'Horse 1';
                    return;
                }

                objectWithValue = objectWithValue[property];
                lastProperty = property;
            });

            secondDisplayValue += objectWithValue + ' ';
        });

        return secondDisplayValue.substring(0, secondDisplayValue.length - 1);
    }

    getSecondLabel(rodeoEvent: RodeoEvent) {
        return rodeoEvent.configuration.runs.slotTwoLabel;
    }

    updateRun(index: number, existingRun: RodeoEventRun) {
        console.log("update run");
        let scheduleIndex = this.scheduleIndices[index];
        let schedule = this._rodeo.rodeoEvents[index].schedules[scheduleIndex];

        existingRun.saving = true;

        if (this.reNumberOnEdit && schedule.runs.some(x => x.id != existingRun.id && x.number == existingRun.number && x.round == existingRun.round)) {
            this.alert.prompt("Multiple Run Edit", "Do you want to re-number all existing runs?", () => {
                let runsToUpdate = [];
                runsToUpdate.push(existingRun);

                let otherRunsToUpdate = this.getRunsToUpdate(schedule, existingRun);

                if (otherRunsToUpdate.length > 0) {
                    runsToUpdate = [...runsToUpdate, ...otherRunsToUpdate];
                }

                this.updateRuns(index, schedule, runsToUpdate);

            }, () => {
                this.updateRuns(index, schedule, [existingRun]);
            })
        } else {
            this.updateRuns(index, schedule, [existingRun]);
        }
    }

    getRunsToUpdate(schedule: RodeoEventSchedule, runToCompare: RodeoEventRun) {
        var runsToUpdate = [];

        var sortedRuns = schedule.runs.sort((a, b) => a.number - b.number);
        var previousRunNumber = 0;

        for (let i = 0; i < sortedRuns.length; i++) {
            var run = sortedRuns[i];

            if (run.round && run.round !== runToCompare.round)
                continue;

            let previousNumberAvailable = run.number !== 1 && i > 0
                && schedule.runs[i - 1].number !== run.number - 1 && previousRunNumber !== run.number;
            let currentNumberAvailable = run.number !== +runToCompare.number && !runsToUpdate.some(x => x.number === run.number);

            if ((currentNumberAvailable && !previousNumberAvailable) || run.id == runToCompare.id) {
                previousRunNumber = run.number;
                continue;
            }

            if (run.number >= +runToCompare.number) {
                if (previousNumberAvailable) {
                    run.number = ++previousRunNumber;
                } else {
                    run.number++;
                }
                runsToUpdate.push(run);
            }

            previousRunNumber = run.number;
        }

        return runsToUpdate;
    }

    updateRuns(rodeoEventIndex: number, schedule: RodeoEventSchedule, runs: any[]) {
        let scheduleIndex = this.scheduleIndices[rodeoEventIndex];

        this.runService.updateRuns(runs)
            .then((data) => {
                (data as RodeoEventRun[]).forEach(run => {
                    run.saving = false;
                    run.error = false;

                    if (run.rodeoEventScheduleId != schedule.id) {
                        schedule.runs = schedule.runs.filter(x => x.id != run.id);
                        let newSchedule = this._rodeo.rodeoEvents[rodeoEventIndex].schedules.filter(x => x.id == run.rodeoEventScheduleId)[0];
                        newSchedule.runs.push(run);

                        if (schedule.name != 'Unassigned') {
                            this.scheduleRuns[rodeoEventIndex].sort((a, b) => {
                                if (a.number < b.number)
                                    return -1;
                                else if (a.number > b.number)
                                    return 1;
                                
                                return 0;
                            });
                        }
                    }
                    else {
                        let runIndex = this._rodeo.rodeoEvents[rodeoEventIndex].schedules[scheduleIndex].runs.findIndex(x => x.id == run.id);
                        this._rodeo.rodeoEvents[rodeoEventIndex].schedules[scheduleIndex].runs[runIndex] = run;
                    }
                });

                if (schedule.name != 'Unassigned') {
                    this.scheduleRuns[rodeoEventIndex].sort((a, b) => {
                        if (a.number < b.number)
                            return -1;
                        else if (a.number > b.number)
                            return 1;
                        
                        return 0;
                    });
                }

                this.buildIssues(rodeoEventIndex);
            }, error => {
                runs.forEach((run) => {
                    run.error = true;
                    run.saving = false;
                });
            });
    }

    addRun(index: number) {
        if (this.popoverActive)
            return;

        let newRunNumber = 1;

        this._rodeo.rodeoEvents[index].schedules[this.scheduleIndices[index]].runs.forEach((run) => {
            if (run.number >= newRunNumber)
                newRunNumber = run.number + 1;
        });

        this.popoverActive = true;
        let entryModal = this.modalCtrl.create(NewRunPage, {
            rodeoEvent: this._rodeo.rodeoEvents[index],
            schedule: this._rodeo.rodeoEvents[index].schedules[this.scheduleIndices[index]],
            organizations: this._organizations,
            runNumber: newRunNumber,
            round: this.selectedRound[index]
        }, { cssClass: 'page-new-run', enableBackdropDismiss: false });

        entryModal.present();
        entryModal.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null && data != undefined) {
                if (!data.run.livestock) {
                    data.run.livestock = new Livestock();
                    data.run.livestock.name = '';
                    data.run.livestock.brand = '';
                }

                let scheduleIndex = this.scheduleIndices[index];
                let schedule = this._rodeo.rodeoEvents[index].schedules[scheduleIndex];
                var runNumberAlreadyExists = schedule.runs.some(x => x.number == data.run.number);
                
                if (!this._rodeo.rodeoEvents[index].schedules[scheduleIndex].runs.some(x => x.id == data.run.id))
                {
                    this._rodeo.rodeoEvents[index].schedules[scheduleIndex].runs.push(data.run);

                    if (!this.scheduleRuns[index])
                        this.scheduleRuns[index] = [];
                    
                    this.scheduleRuns[index].push(data.run);
                }

                if (this.reNumberOnEdit && runNumberAlreadyExists) {
                    this.alert.prompt("Multiple Run Edit", "Do you want to re-number all existing runs?", () => {
                        const runsToUpdate = this.getRunsToUpdate(schedule, data.run);

                        this.updateRuns(index, schedule, runsToUpdate);
                    });
                } else {
                    if (schedule.name != 'Unassigned') {
                        this.scheduleRuns[index].sort((a, b) => {
                            if (a.number < b.number)
                                return -1;
                            else if (a.number > b.number)
                                return 1;
                            
                            return 0;
                        });

                        this.buildIssues(index);
                    }
                }
            }
        });
    }

    drawRodeo(rodeoEvent) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        
        let popover = this.popoverController.create(DrawPromptPage,{
            rodeo: this._rodeo,
            drawSelection: rodeoEvent
        }, {
            cssClass: 'draw-prompt'
        });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data) {
                this._rodeo.drawn = true;

                let rodeoEvent = this._rodeo.rodeoEvents.filter(x => x.id == data.rodeoEventDrawn.id)[0];

                if (rodeoEvent)
                    rodeoEvent.drawn = true;

                this.events.publish("RodeoDrawn", true);
                this.changedSchedule();
                this.pendingEntries = [];
            }
        });
    }

    deleteRun(index: number, run: RodeoEventRun) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let message = `Are you sure you want to remove #${run.number} ${run.contestantOne.firstName} ${run.contestantOne.lastName}? If this is a winning run, it will also remove any points.`;

        let alert = this.alertController.create({
            title: 'Confirm Run Removal',
            message: message,
            buttons: [
                {
                    text: 'Yes',
                    handler: () => {
                        this.runService.deleteRun(run.id)
                            .then(data => {
                                this.runService.addTempDeleted(run.id);

                                this._rodeo.rodeoEvents[index].schedules[this.scheduleIndices[index]].runs = this._rodeo.rodeoEvents[index].schedules[this.scheduleIndices[index]].runs.filter(x => x.id != run.id);
                                this.changedSchedule();

                                let scheduleIndex = this.scheduleIndices[index];
                                let schedule = this._rodeo.rodeoEvents[index].schedules[scheduleIndex];

                                if (this.reNumberOnEdit && schedule.runs.some(x => x.id != run.id && x.number > run.number)) {
                                    this.alert.prompt("Multiple Run Edit", "Do you want to re-number all existing runs?", () => {
                                        let runsToUpdate = this.getRunsToUpdate(schedule, run);

                                        this.updateRuns(index, schedule, runsToUpdate);
                                    })
                                }

                                this.popoverActive = false;
                            }, error => {
                                console.error('error', error);
                                this.alert.showError("Run Removal Error", error);
                                this.popoverActive = false;
                            });
                    }
                },
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => { }
                }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/draw/draw.ts